import './Sos.css'
import { useEffect, useState } from 'react'
import { Modal, Tab, Tabs } from 'react-bootstrap'
import { Siren } from 'lucide-react'
import { Loader } from 'components/loader'
import GuardSosForm from './GuardSosForm'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toggleGuardSosModal } from '../../../../redux/slices/globalSlice'
import { complaintCategoryList } from '../../../../redux/slices/help_desk'
import { useTranslation } from 'react-i18next'

export default function GuardSosModal() {

    const [activeTab, setActiveTab] = useState()
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const show = useSelector((state) => state.global.guardSosModal)
    const complaintCategories = useSelector(state => state?.complaintCategory?.list)
    const loading = useSelector(state => state?.complaintCategory?.loading)

    useEffect(() => {
        if (!show) return
        dispatch(complaintCategoryList({ navigate, type: 'GRD' }))
    }, [show])

    useEffect(() => {
        if (show && complaintCategories?.length) {
            setActiveTab(String(complaintCategories[0].id))
        }
    }, [show, complaintCategories])

    const handleClose = () => {
        setActiveTab()
        dispatch(toggleGuardSosModal())
    }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
            centered
            className="sos-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title as="h5"><Siren size={20} />{t('sos.sos_module')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="d-flex justify-content-center py-4">
                        <Loader />
                    </div>
                ) : (
                    <Tabs
                        activeKey={activeTab}
                        onSelect={(key) => setActiveTab(key)}
                        className="modern_tabs mb-3"
                        variant="pills"
                        fill
                    >
                        {complaintCategories?.map((category) => (
                            <Tab
                                key={category.id}
                                eventKey={String(category.id)}
                                title={category.complaint_category_name}
                            >
                                <GuardSosForm key={category.id} categoryId={category.id} />
                            </Tab>
                        ))}
                    </Tabs>
                )}
            </Modal.Body>
        </Modal>
    )
}
